<template>
  <div class="searchfield input-group">
    <input
      v-click-outside="clickOutside"
      name="q"
      :id="idString + 'Field'"
      class="form-control"
      type="text"
      :placeholder="texts.placeholder"
      :aria-label="texts.sokfalt"
      v-model="query"
      autocomplete="off"
      ref="searchinput"
      @input="onInput"
      @keydown.down.prevent="onArrowDown"
      @keydown.up.prevent="onArrowUp"
    />
    <button
      :id="idString + 'ClearBtn'"
      type="button"
      :class="[this.showClearBtn ? '' : 'd-none', 'btn-reset']"
      @click="clearInput"
    >
      <Icon :type="'cross'"></Icon>
      <span class="visually-hidden">{{ texts.taBortText }}</span>
    </button>
    <button
      ref="submitsearch"
      :id="idString + 'Button'"
      type="submit"
      class="btn-search"
    >
      <Icon v-if="!showAnswer" :type="'search'"></Icon>
      <span v-if="showAnswer" class="searchText">{{ texts.skicka }}</span>
      <span v-else class="searchText">{{ texts.sok }}</span>
    </button>
  </div>
  <AutoComplete
    :autoCompleteItems="autoCompleteItems"
    :query="query"
    :event="event"
    :texts="texts"
    @currentSuggestion="setCurrentSuggestion"
  ></AutoComplete>
</template>

<script>
import clickOutside from "../../plugins/clickOutside";
import sitesearchservice from "../../plugins/sitesearchservice";
import Icon from "../../image/icon.vue";
import AutoComplete from "../../autocomplete/autocomplete.vue";

export default {
  name: "SearchInput",
  directives: {
    clickOutside,
  },
  props: {
    baseApiUrl: String,
    texts: Object,
    suggestSokOptions: Object,
    idString: String,
    showAnswer: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      query: "",
      inputText: "",
      showClearBtn: false,
      autoCompleteItems: undefined,
      event: undefined,
    };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    if (this.suggestSokOptions.Query.length > 0 && urlParams.has("q")) {
      this.query = urlParams.get("q");
    }

    if (this.query.length > 0) {
      this.showClearBtn = true;
    }
  },
  components: {
    Icon,
    AutoComplete,
  },
  methods: {
    clearInput() {
      this.query = "";
      this.autoCompleteItems = [];
      this.showClearBtn = false;
      this.$refs.searchinput.focus();
    },
    onInput() {
      this.inputText = this.query;
      if (this.query.length == 0) {
        this.clearInput();
      } else if (this.query.length > 0) {
        this.showClearBtn = true;
        if (this.query.length >= 2) {
          this.getSuggestions();
        } else {
          this.autoCompleteItems = [];
        }
      }
    },
    onArrowDown($event) {
      this.event = $event;
    },
    onArrowUp($event) {
      this.event = $event;
    },
    setCurrentSuggestion(suggestion, click) {
      if (suggestion == "") {
        this.query = this.inputText;
      } else {
        this.query = suggestion;
      }
      if (click) {
        this.submitForm();
      }
    },
    getSuggestions() {
      sitesearchservice
        .getSuggestions(this.baseApiUrl, this.query, this.suggestSokOptions)
        .then((result) => {
          if (result && result.status === 200) {
            if (this.query.length >= 2) {
              this.autoCompleteItems = result.data;
            } else {
              this.autoCompleteItems = [];
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    submitForm() {
      setTimeout(() => this.$refs.submitsearch.click(), 50);
    },
    clickOutside() {
      this.autoCompleteItems = [];
    },
  },
};
</script>
